import { Columns2, LayoutGrid } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
    MEMBERS_LAYOUT_CLASSIC,
    MEMBERS_LAYOUT_TABLE,
} from '../../hooks/useMembersLayoutMode';

export default function MembersLayoutToggle({ layoutMode, onChange, className = '' }) {
    const { t } = useTranslation();

    return (
        <div
            className={`inline-flex items-center rounded-xl border border-gray-200 bg-gray-100 p-1 dark:border-white/10 dark:bg-gray-900 ${className}`}
            role="group"
            aria-label={t('gym.membersManager.layoutToggle.label')}
        >
            <button
                type="button"
                onClick={() => onChange(MEMBERS_LAYOUT_CLASSIC)}
                className={`inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold transition-colors sm:text-sm ${
                    layoutMode === MEMBERS_LAYOUT_CLASSIC
                        ? 'bg-white text-gray-900 shadow-sm dark:bg-gray-800 dark:text-white'
                        : 'text-gray-600 hover:text-gray-900 dark:text-white/60 dark:hover:text-white'
                }`}
                aria-pressed={layoutMode === MEMBERS_LAYOUT_CLASSIC}
            >
                <LayoutGrid size={16} className="shrink-0" aria-hidden />
                {t('gym.membersManager.layoutToggle.classic')}
            </button>
            <button
                type="button"
                onClick={() => onChange(MEMBERS_LAYOUT_TABLE)}
                className={`inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold transition-colors sm:text-sm ${
                    layoutMode === MEMBERS_LAYOUT_TABLE
                        ? 'bg-white text-gray-900 shadow-sm dark:bg-gray-800 dark:text-white'
                        : 'text-gray-600 hover:text-gray-900 dark:text-white/60 dark:hover:text-white'
                }`}
                aria-pressed={layoutMode === MEMBERS_LAYOUT_TABLE}
            >
                <Columns2 size={16} className="shrink-0" aria-hidden />
                {t('gym.membersManager.layoutToggle.table')}
            </button>
        </div>
    );
}
